module.exports = __webpack_public_path__ + "img/ree_xpsgametoken.93882f2.png";